export default "__VITE_ASSET__WARZmqtM__"